import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { skipToken } from '@reduxjs/toolkit/query';
import { Autocomplete } from '@mui/material';
import userAutocompleteProps from './userAutocompleteProps';
import hasDuplicateById from '../../../../../../../../shared/utils/hasDuplicateById';
import { useGetAppUserResourceQuery } from '../../../../../../../../entities/account/appUsersResource/redux/appUsersResource.api';

function UserSection({ companyId, users, setUsers, initialUserIds }) {
  const { data: { data: rawUserOptions = [] } = {}, isLoading } = useGetAppUserResourceQuery(
    companyId ? { params: { 'companyId.equals': companyId, 'role.in': 'ROLE_COMPANY_ADMIN,ROLE_USER' } } : skipToken,
  );

  const userOptions = useMemo(() => {
    return [...rawUserOptions].sort((a, b) => {
      const firstNameCompare = a.firstName?.localeCompare(b.firstName ?? '') ?? 0;
      if (firstNameCompare !== 0) return firstNameCompare;
      return a.lastName?.localeCompare(b.lastName ?? '') ?? 0;
    });
  }, [rawUserOptions]);

  useEffect(() => {
    const defaultUsers = userOptions?.filter((user) => initialUserIds?.includes(user.appUserId));
    setUsers(defaultUsers);
  }, [userOptions, initialUserIds]);

  const handleChange = (_event, newValue, _target, arg) => {
    const isDuplicate = hasDuplicateById(newValue, arg?.option?.sensorTypeId, 'appUserId');
    if (isDuplicate) return;

    setUsers(newValue);
  };

  return (
    <Autocomplete
      {...userAutocompleteProps}
      options={userOptions}
      value={users}
      onChange={handleChange}
      loading={isLoading}
    />
  );
}

UserSection.propTypes = {
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  users: PropTypes.arrayOf(PropTypes.shape()),
  setUsers: PropTypes.func.isRequired,
  initialUserIds: PropTypes.arrayOf(PropTypes.shape()),
};

UserSection.defaultProps = {
  users: [],
  initialUserIds: [],
};

export default UserSection;
